import { profilePathFromProfile } from '../profileRoutes';
import { isUuid } from '../profileRoutes';
import type { Listing, Profile } from '../../types/database';
import { slugify } from './slugs';

export function seoOrigin(origin?: string): string {
  const fromEnv = process.env.REACT_APP_PUBLIC_SITE_URL?.trim();
  if (origin) return origin.replace(/\/$/, '');
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (typeof window !== 'undefined') return window.location.origin;
  return 'https://district88.com';
}

export function productPath(listing: { id: string; seo_slug?: string | null; title: string }): string {
  if (listing.seo_slug?.trim()) return `/products/${listing.seo_slug.trim()}`;
  const slug = slugify(listing.title);
  if (slug) return `/products/${slug}`;
  return `/products/${listing.id}`;
}

export function productCanonicalUrl(listing: { id: string; seo_slug?: string | null; title: string }, origin?: string): string {
  return `${seoOrigin(origin)}${productPath(listing)}`;
}

export function brandPath(slug: string): string {
  return `/brands/${slug}`;
}

export function modelPath(slug: string): string {
  return `/models/${slug}`;
}

export function colorwayPath(slug: string): string {
  return `/colorways/${slug}`;
}

export function categoryPath(slug: string): string {
  return `/categories/${slug}`;
}

export function cityPath(slug: string): string {
  return `/${slug}`;
}

export function cityBuyPath(citySlug: string, productSlug: string): string {
  return `/buy/${citySlug}/${productSlug}`;
}

export function sellerPath(username: string): string {
  return `/seller/${encodeURIComponent(username)}`;
}

export function sellerListingsPath(username: string): string {
  return `${sellerPath(username)}/listings`;
}

export function sellerReviewsPath(username: string): string {
  return `${sellerPath(username)}/reviews`;
}

export function userPath(username: string): string {
  return `/user/${encodeURIComponent(username)}`;
}

export function profileSeoPath(profile: Pick<Profile, 'username' | 'account_type'>): string {
  if (profile.account_type === 'seller') return sellerPath(profile.username);
  return profilePathFromProfile(profile);
}

export function articlePath(slug: string): string {
  return `/learn/${slug}`;
}

export function releasePath(slug: string): string {
  return `/releases/${slug}`;
}

export function releasesIndexPath(): string {
  return '/releases';
}

export function priceGuidePath(slug: string): string {
  return `/price-guide/${slug}`;
}

export function resolveListingIdFromParam(param: string): string | null {
  if (isUuid(param)) return param;
  return null;
}
